import React, {Fragment, useState} from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

const Formulario = ({crearCita}) => {

    //Crear state de citas
    const [cita, actualizarCita] = useState({
        mascota:'',
        propietario:'',
        fecha:'',
        hora:'',
        sintomas:''
    });

    // State de error al no completar todos los campos
    const [error, actualizarError] = useState(false)

    //Funcion que se ejecuta cada que el usuario escriba en un input
    const actualizarState = e => {
        actualizarCita({
            ...cita, [e.target.name] : e.target.value
        })
    }

    //Extraer los valores
    const { mascota, propietario, fecha, hora, sintomas } = cita

    //Enviar el form
    const submitCita = e => {
        e.preventDefault();
        
        // Validar
        if(mascota.trim() === '' || propietario.trim() === '' || fecha.trim() === '' || hora.trim() === '' || sintomas.trim() === ''){
            actualizarError(true);
            return; //para que no se siga ejecutando el codigo
        }

        // Eliminar el mensaje previo
        actualizarError(false);

        // Asignar ID
        cita.id = uuidv4();

        //Crear la CIta
        crearCita(cita);

        //Resetear el form
        actualizarCita({
                mascota:'',
                propietario:'',
                fecha:'',
                hora:'',
               sintomas:''
            
        })
    }

    

    return (
        <Fragment>
            <h2>Crear Cita</h2>

            { error ? <p className="alerta-error">Todos los campos son obligatorios</p> : null}

            <form 
            onSubmit={submitCita}
            >
                <label>Nombre de mascota</label>
                <input 
                type="text"
                name="mascota"
                className="u-full-width"
                placeholder="Nombre de mascota"
                onChange={actualizarState}
                value={mascota}
                />
                <label>Nombre del dueño</label>
                <input 
                type="text"
                name="propietario"
                className="u-full-width"
                placeholder="Nombre del dueño"
                onChange={actualizarState}
                value={propietario}
                />
                <label>Fecha</label>
                <input 
                type="date"
                name="fecha"
                className="u-full-width"   
                onChange={actualizarState}     
                value={fecha}        
                />
                <label>Hora</label>
                <input 
                type="time"
                name="hora"
                className="u-full-width"
                onChange={actualizarState}
                value={hora}
                />
                <label>Sintomas</label>
               <textarea 
               className="u-full-width" 
               name="sintomas"
               onChange={actualizarState}
               value={sintomas}
               >
               </textarea>
               <button
               type="submit"
               className="u-full-width button-primary"
               >
                Agregar Cita
               </button>
            </form>
        </Fragment>
    )
}

Formulario.propTypes = {
    crearCita: PropTypes.func.isRequired
}


export default Formulario;